import { mergeAttributes, Node } from '@tiptap/core';

export const FileNode = Node.create({
  name: 'file',
  group: 'block',
  atom: true,
  selectable: true,

  addOptions() {
    return {
      icons: {
        word: 'assets/svgs/word.svg',
        file: 'assets/svgs/file.svg',
        pdf: 'assets/svgs/file-pdf.svg',
        information: 'assets/svgs/information.svg'
      },
      HTMLAttributes: { class: 'file-node' }
    };
  },

  addAttributes() {
    return {
      attachmentId: { default: '' },
      name: { default: '' },
      mime: { default: '' },
      size: { default: 0 }
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const { name, mime, attachmentId, size } = node.attrs;

    const fileTypeIcon = getFileTypeIcon(name, this.options.icons);

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'file-node file-wrapper',
        'data-attachment-id': attachmentId,
        'data-name': name,
        'data-mime': mime,
        'data-size': size,
        contenteditable: 'false'
      }),
      [
        'div',
        { class: 'file-button file-border tiptap-file-button' },
        [
          'div',
          { class: 'file-actions tiptap-file-actions' },

          ...(fileTypeIcon ? [['img', { class: 'tiptap-file-type-icon', src: fileTypeIcon, alt: '' }]] : []),

          ['span', { class: 'clamp-text file-name-button tiptap-file-name' }, name],

          ['span', { class: 'tiptap-file-size' }, `(${formatFileSize(size)})`]
        ]
      ]
    ];
  },

  parseHTML() {
    return [{ tag: 'div.file-node' }];
  }
});

function getFileTypeIcon(fileName: string, icons: Record<string, string>): string | null {
  if (!fileName) return null;

  const extension = fileName.split('.').pop()?.toLowerCase();

  const fileIconMap: Record<string, string> = {
    doc: icons['word'],
    docx: icons['word'],
    txt: icons['file'],
    pdf: icons['pdf']
  };

  return fileIconMap[extension ?? ''] ?? icons['file'];
}

function formatFileSize(sizeInBytes: number): string {
  if (!sizeInBytes || sizeInBytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));

  return `${(sizeInBytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
}
